import { cn } from "@/lib/utils";
import { useI18N } from "common/hooks";
import { OpeningHour } from "common/types";
import { Clock } from "phosphor-react";

interface OpeningHoursProps {
  openingHours?: OpeningHour[];
  containerClassName?: string;
  className?: string;
}

const OpeningHours = ({
  openingHours,
  containerClassName,
  className,
}: OpeningHoursProps) => {
  const i18n = useI18N();

  const getTodaysOpeningHours = () => {
    const today = new Date().getDay(); // Gets today's day of the week as a number
    const openingHoursToday = openingHours?.find((hour) => hour.day === today);

    if (openingHoursToday) {
      const openTime = formatTime(openingHoursToday.openTime);
      const closeTime = formatTime(openingHoursToday.closeTime);
      return `${openTime} - ${closeTime}`;
    }
    return <span>{i18n.get("closedToday")}</span>;
  };

  const formatTime = (time: any) => {
    if (typeof time !== "number" || isNaN(time)) {
      return <span>{i18n.get("invalidTime")}</span>; // Returns 'Invalid Time' if the input is not a valid number
    }

    const hours = Math.floor(time / 100);
    const minutes = time % 100;
    const amPm = hours >= 12 ? "PM" : "AM";
    const formattedHour = hours % 12 || 12;

    // Ensure minutes are always two digits
    const formattedMinutes = minutes < 10 ? "0" + minutes : minutes.toString();

    return `${formattedHour}:${formattedMinutes} ${amPm}`;
  };

  return (
    <div
      className={cn(
        containerClassName,
        "flex flex-row items-center truncate text-ellipsis"
      )}
      tabIndex={0}
      aria-label={`Opening Hours: ${getTodaysOpeningHours()}`}
    >
      <div>
        <Clock size={24} className="!text-primary-500 dark:!text-primary-300" aria-hidden="true" />
      </div>
      <p className={cn(className, "ml-1")}>Hours: {getTodaysOpeningHours()}</p>
    </div>
  );
};

export default OpeningHours;
